export const MAX_SLUG_LENGTH = 30;
export const ROOM_WIDGET_IMAGE_SIZE_UPLOAD_LIMIT = '5 Mb';
export const ROOM_WIDGET_IMAGES_COUNT_LIMIT = 30;
